import { printerDetailQueryAtom } from '../_graphql/queryPrinterDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

export const $printerSidecarId = settingsRouteParamAtom(
  ['/hardware/printers/:sidecarId/:printerId'],
  'sidecarId',
);

export const $printerId = settingsRouteParamAtom(
  ['/hardware/printers/:sidecarId/:printerId'],
  'printerId',
);

export const $remotePrinterDetail = printerDetailQueryAtom((get) => {
  const printerId = get($printerId);
  return {
    variables: {
      ids: printerId ? [printerId] : [],
    },
    skip: !printerId,
  };
});
